!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("informed", [], t) : "object" == typeof exports ? exports.informed = t() : e.informed = t();
}(this, function () {
  return function (e) {
    var t = {};
    function __webpack_require__(r) {
      if (t[r]) return t[r].exports;
      var n = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, r) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) __webpack_require__.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
      return r;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 22);
  }([function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
  }, function (e, t) {
    e.exports = require("react");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/extends");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/objectWithoutProperties");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/classCallCheck");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/createClass");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/possibleConstructorReturn");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/getPrototypeOf");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/inherits");
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SelectContext = t.GroupContext = t.FieldContext = t.FormContext = void 0;
    var a = n(r(1)),
      u = a.default.createContext();
    t.FormContext = u;
    var i = a.default.createContext();
    t.FieldContext = i;
    var o = a.default.createContext();
    t.GroupContext = o;
    var l = a.default.createContext();
    t.SelectContext = l;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
      u = n(r(1)),
      i = n(r(19));
    var o = function asField(e) {
      var t = function getDisplayName(e) {
        return e.displayName || e.name || "Component";
      }(e);
      e.displayName = "Wrapper";
      var r = function AsField(t) {
        return u.default.createElement(i.default, (0, a.default)({
          component: e
        }, t));
      };
      return r.displayName = t, r;
    };
    t.default = o;
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/assertThisInitialized");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/objectSpread");
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
      u = n(r(1)),
      i = r(9),
      o = function withFormApi(e) {
        return u.default.forwardRef(function (t, r) {
          return u.default.createElement(i.FormContext.Consumer, null, function (n) {
            var i = n.formApi;
            return u.default.createElement(e, (0, a.default)({
              formApi: i,
              ref: r
            }, t));
          });
        });
      };
    t.default = o;
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/core-js/map");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/core-js/json/stringify");
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
      u = n(r(1)),
      i = r(9),
      o = function withFormState(e) {
        return u.default.forwardRef(function (t, r) {
          return u.default.createElement(i.FormContext.Consumer, null, function (n) {
            var i = n.formState;
            return u.default.createElement(e, (0, a.default)({
              formState: i,
              ref: r
            }, t));
          });
        });
      };
    t.default = o;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
      u = n(r(1)),
      i = r(9),
      o = function withController(e) {
        return u.default.forwardRef(function (t, r) {
          return u.default.createElement(i.FormContext.Consumer, null, function (n) {
            var i = n.controller;
            return u.default.createElement(e, (0, a.default)({
              controller: i,
              ref: r
            }, t));
          });
        });
      };
    t.default = o;
  }, function (e, t, r) {
    "use strict";

    var n = r(11),
      a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var u = a(r(13)),
      i = a(r(3)),
      o = a(r(4)),
      l = a(r(5)),
      d = a(r(6)),
      f = a(r(7)),
      c = a(r(8)),
      s = n(r(1)),
      p = r(20),
      h = function (e) {
        function Field(e) {
          var t;
          return (0, o.default)(this, Field), (t = (0, d.default)(this, (0, f.default)(Field).call(this, e))).me = s.default.createRef(), t;
        }
        return (0, c.default)(Field, e), (0, l.default)(Field, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this.props.register();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            this.props.deregister();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            var e = this;
            this.props.debug && this.me && (this.me.current.style.backgroundColor = "red", setTimeout(function () {
              e.me.current.style.backgroundColor = "white";
            }, 500));
          }
        }, {
          key: "render",
          value: function render() {
            var e = this.props,
              t = e.fieldApi,
              r = e.fieldState,
              n = e.children,
              a = e.component,
              render = e.render,
              o = (e.register, e.deregister, e.forwardedRef),
              l = e.debug,
              d = (0, i.default)(e, ["fieldApi", "fieldState", "children", "component", "render", "register", "deregister", "forwardedRef", "debug"]),
              f = (0, u.default)({
                fieldApi: t,
                fieldState: r,
                forwardedRef: l ? this.me : o
              }, d);
            return a ? s.default.createElement(a, f, n) : render ? render(f) : "function" == typeof n ? n(f) : n;
          }
        }]), Field;
      }(s.PureComponent),
      v = (0, p.bindToField)(h);
    t.default = v;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.bindToField = t.withFieldState = t.withFieldApi = void 0;
    var a = n(r(4)),
      u = n(r(5)),
      i = n(r(6)),
      o = n(r(7)),
      l = n(r(8)),
      d = n(r(12)),
      f = n(r(2)),
      c = n(r(3)),
      s = n(r(1)),
      p = n(r(14)),
      h = n(r(18)),
      v = n(r(35)),
      g = function buildFieldApi(e, t) {
        return {
          getValue: function getValue() {
            return e.getValue(t);
          },
          setValue: function setValue(r) {
            return e.setValue(t, r);
          },
          getTouched: function getTouched() {
            return e.getTouched(t);
          },
          setTouched: function setTouched(r) {
            return e.setTouched(t, r);
          },
          getError: function getError() {
            return e.getError(t);
          },
          setError: function setError(r) {
            return e.setError(t, r);
          },
          getAsyncError: function getAsyncError() {
            return e.getAsyncError(t);
          }
        };
      },
      m = function buildFieldState(e, t) {
        return {
          value: e.getValue(t),
          touched: e.getTouched(t),
          error: e.getError(t),
          asyncError: e.getAsyncError(t)
        };
      };
    t.withFieldApi = function withFieldApi(e) {
      return function (t) {
        return (0, p.default)(function (r) {
          var n = r.formApi,
            a = (0, c.default)(r, ["formApi"]);
          return s.default.createElement(t, (0, f.default)({
            fieldApi: g(n, e)
          }, a));
        });
      };
    };
    t.withFieldState = function withFieldState(e) {
      return function (t) {
        return (0, p.default)(function (r) {
          var n = r.formApi,
            a = (0, c.default)(r, ["formApi"]);
          return s.default.createElement(t, (0, f.default)({
            fieldState: m(n, e)
          }, a));
        });
      };
    };
    t.bindToField = function bindToField(e) {
      return (0, h.default)((0, p.default)(function (t) {
        function _class(e) {
          var t;
          (0, a.default)(this, _class), t = (0, i.default)(this, (0, o.default)(_class).call(this, e));
          var r = e.formApi,
            n = e.controller,
            u = e.field,
            l = e.mask,
            f = e.validate,
            c = e.onValueChange,
            s = e.asyncValidate,
            p = e.asyncValidateOnBlur,
            h = e.validateOnBlur,
            b = e.validateOnChange,
            y = e.initialValue,
            _ = e.validateOnMount,
            C = e.notify;
          t.state = m(r, u), t.fieldApi = g(r, u);
          var j = function updateMe(e) {
              e === r.getFullField(u) && t.setState(m(r, u));
            },
            O = function update() {
              t.setState(m(r, u));
            };
          return t.register = function () {
            n.on("field", j), n.on("update", O), t.fieldController = new v.default(r.getFullField(u), t.fieldApi, {
              validateOnBlur: h,
              validateOnChange: b,
              validate: f,
              onValueChange: c,
              asyncValidate: s,
              asyncValidateOnBlur: p,
              initialValue: y,
              validateOnMount: _,
              notify: C,
              mask: l
            }), n.register(r.getFullField(u), t.fieldController);
          }, t.deregister = function () {
            n.removeListener("field", j), n.removeListener("update", O), n.deregister(r.getFullField(u));
          }, t.register = t.register.bind((0, d.default)((0, d.default)(t))), t.deregister = t.deregister.bind((0, d.default)((0, d.default)(t))), t;
        }
        return (0, l.default)(_class, t), (0, u.default)(_class, [{
          key: "componentDidUpdate",
          value: function componentDidUpdate(e) {
            var t = this.props,
              r = t.validateOnBlur,
              n = t.validateOnChange,
              a = t.validate,
              u = t.onValueChange,
              i = t.asyncValidate,
              o = t.asyncValidateOnBlur,
              l = t.initialValue,
              d = t.validateOnMount,
              f = t.notify,
              c = t.mask;
            this.fieldController.updateConfig({
              validateOnBlur: r,
              validateOnChange: n,
              validate: a,
              onValueChange: u,
              asyncValidate: i,
              asyncValidateOnBlur: o,
              initialValue: l,
              validateOnMount: d,
              notify: f,
              mask: c
            });
          }
        }, {
          key: "render",
          value: function render() {
            var t = this.props,
              r = (t.mask, t.formApi, t.formState, t.controller, t.validate, t.onValueChange, t.asyncValidate, t.asyncValidateOnBlur, t.validateOnBlur, t.validateOnMount, t.validateOnChange, (0, c.default)(t, ["mask", "formApi", "formState", "controller", "validate", "onValueChange", "asyncValidate", "asyncValidateOnBlur", "validateOnBlur", "validateOnMount", "validateOnChange"]));
            return s.default.createElement(e, (0, f.default)({
              register: this.register,
              deregister: this.deregister,
              fieldApi: this.fieldApi,
              fieldState: this.state
            }, r));
          }
        }]), _class;
      }(s.default.PureComponent)));
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
      u = n(r(1)),
      i = r(9),
      o = function withRadioGroup(e) {
        return u.default.forwardRef(function (t, r) {
          return u.default.createElement(i.GroupContext.Consumer, null, function (n) {
            var i = n.radioGroupApi,
              o = n.radioGroupState;
            return u.default.createElement(e, (0, a.default)({
              radioGroupApi: i,
              radioGroupState: o,
              ref: r
            }, t));
          });
        });
      };
    t.default = o;
  }, function (e, t, r) {
    "use strict";

    var n = r(11),
      a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "Form", {
      enumerable: !0,
      get: function get() {
        return u.default;
      }
    }), Object.defineProperty(t, "Scope", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    }), Object.defineProperty(t, "Field", {
      enumerable: !0,
      get: function get() {
        return o.default;
      }
    }), Object.defineProperty(t, "withFormApi", {
      enumerable: !0,
      get: function get() {
        return l.default;
      }
    }), Object.defineProperty(t, "withFormState", {
      enumerable: !0,
      get: function get() {
        return d.default;
      }
    }), Object.defineProperty(t, "withFieldApi", {
      enumerable: !0,
      get: function get() {
        return f.withFieldApi;
      }
    }), Object.defineProperty(t, "withFieldState", {
      enumerable: !0,
      get: function get() {
        return f.withFieldState;
      }
    }), Object.defineProperty(t, "withRadioGroup", {
      enumerable: !0,
      get: function get() {
        return c.default;
      }
    }), Object.defineProperty(t, "asField", {
      enumerable: !0,
      get: function get() {
        return s.default;
      }
    }), Object.defineProperty(t, "Text", {
      enumerable: !0,
      get: function get() {
        return p.default;
      }
    }), Object.defineProperty(t, "BasicText", {
      enumerable: !0,
      get: function get() {
        return p.BasicText;
      }
    }), Object.defineProperty(t, "Radio", {
      enumerable: !0,
      get: function get() {
        return h.default;
      }
    }), Object.defineProperty(t, "BasicRadio", {
      enumerable: !0,
      get: function get() {
        return h.BasicRadio;
      }
    }), Object.defineProperty(t, "TextArea", {
      enumerable: !0,
      get: function get() {
        return v.default;
      }
    }), Object.defineProperty(t, "BasicTextArea", {
      enumerable: !0,
      get: function get() {
        return v.BasicTextArea;
      }
    }), Object.defineProperty(t, "Select", {
      enumerable: !0,
      get: function get() {
        return g.default;
      }
    }), Object.defineProperty(t, "BasicSelect", {
      enumerable: !0,
      get: function get() {
        return g.BasicSelect;
      }
    }), Object.defineProperty(t, "Option", {
      enumerable: !0,
      get: function get() {
        return m.default;
      }
    }), Object.defineProperty(t, "Checkbox", {
      enumerable: !0,
      get: function get() {
        return b.default;
      }
    }), Object.defineProperty(t, "BasicCheckbox", {
      enumerable: !0,
      get: function get() {
        return b.BasicCheckbox;
      }
    }), Object.defineProperty(t, "RadioGroup", {
      enumerable: !0,
      get: function get() {
        return y.default;
      }
    }), Object.defineProperty(t, "BasicRadioGroup", {
      enumerable: !0,
      get: function get() {
        return y.BasicRadioGroup;
      }
    });
    var u = a(r(23)),
      i = a(r(34)),
      o = a(r(19)),
      l = a(r(14)),
      d = a(r(17)),
      f = r(20),
      c = a(r(21)),
      s = a(r(10)),
      p = n(r(36)),
      h = n(r(37)),
      v = n(r(38)),
      g = n(r(39)),
      m = a(r(41)),
      b = n(r(42)),
      y = n(r(43));
  }, function (e, t, r) {
    "use strict";

    var n = r(11),
      a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var u = a(r(2)),
      i = a(r(3)),
      o = a(r(4)),
      l = a(r(5)),
      d = a(r(6)),
      f = a(r(7)),
      c = a(r(8)),
      s = n(r(1)),
      p = r(9),
      h = a(r(24)),
      v = function (e) {
        function Form(e) {
          var t;
          (0, o.default)(this, Form), t = (0, d.default)(this, (0, f.default)(Form).call(this, e));
          var r = e.onSubmit,
            n = e.preSubmit,
            a = e.getApi,
            u = e.dontPreventDefault,
            i = e.onSubmitFailure,
            l = e.initialValues;
          return t.controller = new h.default({
            onSubmit: r,
            getApi: a,
            preSubmit: n,
            onSubmitFailure: i
          }, {
            dontPreventDefault: u,
            initialValues: l
          }), t.controller.on("change", function () {
            return t.forceUpdate();
          }), t.controller.on("change", function (t) {
            e.onChange && e.onChange(t);
          }), t.controller.on("values", function (t) {
            e.onValueChange && e.onValueChange(t);
          }), t;
        }
        return (0, c.default)(Form, e), (0, l.default)(Form, [{
          key: "render",
          value: function render() {
            var e = this.props,
              t = (e.children, e.component, e.render, e.onSubmit, e.preSubmit, e.getApi, e.dontPreventDefault, e.onSubmitFailure, e.initialValues, e.onValueChange, e.onChange, (0, i.default)(e, ["children", "component", "render", "onSubmit", "preSubmit", "getApi", "dontPreventDefault", "onSubmitFailure", "initialValues", "onValueChange", "onChange"]));
            return s.default.createElement(p.FormContext.Provider, {
              value: this.formContext
            }, s.default.createElement("form", (0, u.default)({}, t, {
              onReset: this.formContext.formApi.reset,
              onSubmit: this.formContext.formApi.submitForm
            }), this.content));
          }
        }, {
          key: "formContext",
          get: function get() {
            return {
              formApi: this.controller.api,
              formState: this.controller.state,
              controller: this.controller
            };
          }
        }, {
          key: "content",
          get: function get() {
            var e = this.props,
              t = e.children,
              r = e.component,
              n = e.render,
              a = this.formContext;
            return r ? s.default.createElement(r, a, t) : n ? n(a) : "function" == typeof t ? t(a) : t;
          }
        }]), Form;
      }(s.Component);
    t.default = v;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(15)),
      u = n(r(25)),
      i = n(r(26)),
      o = n(r(27)),
      l = n(r(16)),
      d = n(r(4)),
      f = n(r(5)),
      c = n(r(6)),
      s = n(r(7)),
      p = n(r(8)),
      h = n(r(12)),
      v = n(r(28)),
      g = n(r(29)),
      m = function (e) {
        function FormController() {
          var e,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return (0, d.default)(this, FormController), e = (0, c.default)(this, (0, s.default)(FormController).call(this)), (0, v.default)((0, h.default)((0, h.default)(e)), "valid", function () {
            return e.errors.empty() && e.asyncErrors.empty();
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "getFormState", function () {
            return JSON.parse((0, l.default)(e.state));
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "setFormState", function (t) {
            e.values.rebuild(t.values), e.touched.rebuild(t.touched), e.errors.rebuild(t.errors), e.asyncErrors.rebuild(), e.emit("change", e.state), e.emit("values", e.state.values), e.emit("update", e.state);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "setValues", function (t) {
            e.values.rebuild(t), e.emit("change", e.state), e.emit("values", e.state.values), e.emit("update", e.state);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "validateAsync", function () {
            var t = (0, o.default)(i.default.mark(function _callee(t, r) {
              var n, a, u;
              return i.default.wrap(function _callee$(i) {
                for (;;) switch (i.prev = i.next) {
                  case 0:
                    return n = Math.random(), e.validationPromiseIDs.set(r, n), i.prev = 2, a = t.asyncValidate(e.state.values), i.next = 6, a;
                  case 6:
                    if (u = i.sent, e.validationPromiseIDs.get(r) === n) {
                      i.next = 9;
                      break;
                    }
                    return i.abrupt("return");
                  case 9:
                    e.asyncErrors.set(r, u), i.next = 14;
                    break;
                  case 12:
                    i.prev = 12, i.t0 = i.catch(2);
                  case 14:
                    e.notify(t.config.notify), e.emit("change", e.state), e.emit("field", r);
                  case 17:
                  case "end":
                    return i.stop();
                }
              }, _callee, this, [[2, 12]]);
            }));
            return function (e, r) {
              return t.apply(this, arguments);
            };
          }()), (0, v.default)((0, h.default)((0, h.default)(e)), "setValue", function (t, r) {
            var n = e.fields.get(t);
            e.values.set(t, n.config.mask ? n.config.mask(r) : r), n.config.validateOnChange && (e.errors.set(t, n.validate(e.state.values)), e.notify(n.config.notify)), e.emit("change", e.state), e.emit("values", e.state.values), e.emit("field", t), n.config.onValueChange && n.config.onValueChange(e.values.get(t));
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "setTouched", function (t) {
            var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            e.touched.set(t, r);
            var n = e.fields.get(t);
            n.config.validateOnBlur && (e.errors.set(t, n.validate(e.state.values)), e.notify(n.config.notify)), n.config.asyncValidateOnBlur && e.validateAsync(n, t), e.emit("change", e.state), e.emit("field", t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "setError", function (t, r) {
            e.errors.set(t, r), e.emit("change", e.state), e.emit("field", t);
            var n = e.fields.get(t);
            e.notify(n.config.notify);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "getValue", function (t) {
            return e.values.get(t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "getTouched", function (t) {
            return e.touched.get(t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "getError", function (t) {
            return e.errors.get(t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "getAsyncError", function (t) {
            return e.asyncErrors.get(t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "getFullField", function (e) {
            return e;
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "register", function (t, r) {
            e.fields.set(t, r), null != r.config.initialValue && e.values.set(t, r.config.initialValue), r.config.validateOnMount && e.errors.set(t, r.validate(e.state.values)), e.emit("change", e.state), e.emit("field", t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "remove", function (t) {
            e.fields.delete(t), e.values.delete(t), e.touched.delete(t), e.errors.delete(t), e.asyncErrors.delete(t), e.emit("change", e.state);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "deregister", function (t) {
            e.remove(t), e.emit("change", e.state), e.emit("field", t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "reset", function () {
            e.values.rebuild(e.config.initialValues), e.touched.rebuild(), e.errors.rebuild(), e.asyncErrors.rebuild(), e.submits = 0, e.fields.forEach(function (t) {
              t.config.initialValue && e.values.set(t.field, t.config.initialValue);
            }), e.emit("change", e.state), e.emit("update", e.state);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "fieldExists", function (t) {
            return !!e.fields.get(t);
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "notify", function (t) {
            t && (t.forEach(function (t) {
              var r = e.fields.get(t);
              if (!r) throw new Error("Cant notify field ".concat(t, " as it does not exist!"));
              e.errors.set(t, r.validate(e.state.values)), e.emit("field", t);
            }), e.emit("change", e.state));
          }), (0, v.default)((0, h.default)((0, h.default)(e)), "submitForm", function () {
            var t = (0, o.default)(i.default.mark(function _callee2(t) {
              var r;
              return i.default.wrap(function _callee2$(n) {
                for (;;) switch (n.prev = n.next) {
                  case 0:
                    return e.submits = e.submits + 1, t && !e.config.dontPreventDefault && t.preventDefault(t), r = [], e.fields.forEach(function (t) {
                      var n = t.field;
                      e.touched.set(n, !0), e.errors.set(n, t.validate(e.state.values)), t.asyncValidate && (e.errors.get(n) || r.push(function () {
                        return e.validateAsync(t, n);
                      }));
                    }), n.next = 6, u.default.all(r.map(function (e) {
                      return e();
                    }));
                  case 6:
                    e.emit("change", e.state), e.emit("update", e.state), e.valid() ? (e.hooks.preSubmit && (e.values.rebuild(e.hooks.preSubmit(JSON.parse((0, l.default)(e.state.values)))), e.emit("change", e.state), e.emit("update", e.state)), e.hooks.onSubmit && e.hooks.onSubmit(JSON.parse((0, l.default)(e.state.values)))) : e.hooks.onSubmitFailure && e.hooks.onSubmitFailure(JSON.parse((0, l.default)(e.state.errors)), JSON.parse((0, l.default)(e.state.asyncErrors)));
                  case 9:
                  case "end":
                    return n.stop();
                }
              }, _callee2, this);
            }));
            return function (e) {
              return t.apply(this, arguments);
            };
          }()), e.setMaxListeners(0), e.hooks = t, e.config = r, e.values = new g.default(r.initialValues), e.touched = new g.default(), e.errors = new g.default(), e.submits = 0, e.asyncErrors = new g.default(), e.api = {
            setValue: e.setValue,
            getValue: e.getValue,
            setTouched: e.setTouched,
            getTouched: e.getTouched,
            setError: e.setError,
            getError: e.getError,
            getAsyncError: e.getAsyncError,
            getFullField: e.getFullField,
            submitForm: e.submitForm,
            getState: e.getFormState,
            setState: e.setFormState,
            setValues: e.setValues,
            reset: e.reset,
            notify: e.notify,
            fieldExists: e.fieldExists
          }, e.fields = new a.default(), e.validationPromiseIDs = new a.default(), t.getApi && t.getApi(e.api), e;
        }
        return (0, p.default)(FormController, e), (0, f.default)(FormController, [{
          key: "state",
          get: function get() {
            return {
              values: this.values.object,
              touched: this.touched.object,
              errors: this.errors.object,
              asyncErrors: this.asyncErrors.object,
              pristine: this.pristine,
              dirty: this.dirty,
              invalid: this.invalid,
              submits: this.submits
            };
          }
        }, {
          key: "pristine",
          get: function get() {
            return this.touched.empty() && this.values.empty();
          }
        }, {
          key: "dirty",
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: "invalid",
          get: function get() {
            return !this.errors.empty() || !this.asyncErrors.empty();
          }
        }]), FormController;
      }(r(33).EventEmitter);
    t.default = m;
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/core-js/promise");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/regenerator");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/asyncToGenerator");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/defineProperty");
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(16)),
      u = n(r(4)),
      i = n(r(5)),
      o = n(r(30)),
      l = n(r(15)),
      d = n(r(31)),
      f = n(r(32));
    function isArray(e) {
      return Array.isArray(e);
    }
    function isObject(e) {
      return !Array.isArray(e) && "object" === (0, d.default)(e) && null !== e;
    }
    var c = function buildMap(e) {
        if (isObject(e)) {
          var t = new l.default();
          return (0, o.default)(e).forEach(function (r) {
            var n = buildMap(e[r]);
            null != n && t.set(r, n);
          }), t;
        }
        if (isArray(e)) {
          var r = new l.default();
          return e.forEach(function (e, t) {
            var n = buildMap(e);
            null != n && r.set(t, n);
          }), r;
        }
        return e;
      },
      s = function () {
        function ObjectMap() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          (0, u.default)(this, ObjectMap), this.object = JSON.parse((0, a.default)(e)), this.map = c(this.object), this.paths = new l.default();
        }
        return (0, i.default)(ObjectMap, [{
          key: "empty",
          value: function empty() {
            return 0 === this.map.size;
          }
        }, {
          key: "rebuild",
          value: function rebuild() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.object = JSON.parse((0, a.default)(e)), this.map = c(this.object);
          }
        }, {
          key: "get",
          value: function get(e) {
            var t = this.paths.get(e);
            t || (t = (0, f.default)(e), this.paths.set(e, t));
            var get = function get(e, r, n, a) {
              if (null != e) return null == n ? e[r] : get(e[r], t[a + 1], t[a + 2], a + 1);
            };
            return get(this.object, t[0], t[1], 0);
          }
        }, {
          key: "set",
          value: function set(e, t, r) {
            var n = this.paths.get(e);
            n || (n = (0, f.default)(e), this.paths.set(e, n));
            var set = function set(e, a, u, i, o) {
              if (null != e) if (null != i) {
                null != t && ("number" != typeof i || isArray(e[u]) || (e[u] = [], a.set(u, new l.default())), "number" == typeof i || isObject(e[u]) || (e[u] = {}, a.set(u, new l.default())));
                var d = isObject(e[u]) || isArray(e[u]) ? a.get(u) : a;
                set(e[u], d, n[o + 1], n[o + 2], o + 1), 0 === d.size && (delete e[u], a.delete(u));
              } else null == t ? (isArray(e) && r ? e.splice(u, 1) : delete e[u], a.delete(u)) : (e[u] = t, a.set(u, t));
            };
            set(this.object, this.map, n[0], n[1], 0);
          }
        }, {
          key: "delete",
          value: function _delete(e) {
            this.set(e, null, !0), this.paths.delete(e);
          }
        }]), ObjectMap;
      }();
    t.default = s;
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/core-js/object/keys");
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/typeof");
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = function makePathArray(e) {
      return e.replace(/\[(\d+)]/g, ".__int__$1").replace(/\['([^.]+)']/g, ".$1").split(".").map(function (e) {
        return 0 === e.indexOf("__int__") ? parseInt(e.substring(7), 10) : e;
      });
    };
    t.default = n;
  }, function (e, t) {
    e.exports = require("events");
  }, function (e, t, r) {
    "use strict";

    var n = r(11),
      a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var u = a(r(4)),
      i = a(r(5)),
      o = a(r(6)),
      l = a(r(7)),
      d = a(r(8)),
      f = a(r(13)),
      c = n(r(1)),
      s = r(9),
      p = a(r(14)),
      h = a(r(17)),
      v = a(r(18)),
      g = function buildScopedContext(e, t, r, n) {
        return {
          formApi: (0, f.default)({}, t, {
            getValue: function getValue(r) {
              return t.getValue("".concat(e, ".").concat(r));
            },
            setValue: function setValue(r, n) {
              return t.setValue("".concat(e, ".").concat(r), n);
            },
            getTouched: function getTouched(r) {
              return t.getTouched("".concat(e, ".").concat(r));
            },
            setTouched: function setTouched(r, n) {
              return t.setTouched("".concat(e, ".").concat(r), n);
            },
            getError: function getError(r) {
              return t.getError("".concat(e, ".").concat(r));
            },
            setError: function setError(r, n) {
              return t.setError("".concat(e, ".").concat(r), n);
            },
            getAsyncError: function getAsyncError(r) {
              return t.getAsyncError("".concat(e, ".").concat(r));
            },
            getFullField: function getFullField(r) {
              return "".concat(t.getFullField(e), ".").concat(r);
            }
          }),
          formState: r,
          controller: n
        };
      },
      m = function (e) {
        function Scope(e) {
          var t;
          (0, u.default)(this, Scope), t = (0, o.default)(this, (0, l.default)(Scope).call(this, e));
          var r = e.scope,
            n = e.formApi,
            a = e.formState,
            i = e.controller;
          return t.formContext = g(r, n, a, i), t;
        }
        return (0, d.default)(Scope, e), (0, i.default)(Scope, [{
          key: "render",
          value: function render() {
            var e = this.props.children;
            return c.default.createElement(s.FormContext.Provider, {
              value: this.formContext
            }, e);
          }
        }]), Scope;
      }(c.Component),
      b = (0, h.default)((0, v.default)((0, p.default)(m)));
    t.default = b;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(4)),
      u = n(r(5)),
      i = function () {
        function FieldController(e, t, r) {
          (0, a.default)(this, FieldController), this.field = e, this.config = r, this.api = t;
        }
        return (0, u.default)(FieldController, [{
          key: "validate",
          value: function validate(e) {
            if (this.config.validate) return this.config.validate(this.api.getValue(), e);
          }
        }, {
          key: "asyncValidate",
          value: function asyncValidate(e) {
            if (this.config.asyncValidate) return this.config.asyncValidate(this.api.getValue(), e);
          }
        }, {
          key: "updateConfig",
          value: function updateConfig(e) {
            this.config = e;
          }
        }]), FieldController;
      }();
    t.default = i;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BasicText = void 0;
    var a = n(r(2)),
      u = n(r(3)),
      i = n(r(1)),
      o = n(r(10)),
      l = function Text(e) {
        var t = e.fieldApi,
          r = e.fieldState,
          n = (0, u.default)(e, ["fieldApi", "fieldState"]),
          o = r.value,
          l = t.setValue,
          d = t.setTouched,
          f = n.onChange,
          c = n.onBlur,
          s = n.field,
          p = (n.initialValue, n.forwardedRef),
          h = (0, u.default)(n, ["onChange", "onBlur", "field", "initialValue", "forwardedRef"]);
        return i.default.createElement("input", (0, a.default)({}, h, {
          name: s,
          ref: p,
          value: o || 0 === o ? o : "",
          onChange: function onChange(e) {
            l(e.target.value), f && f(e);
          },
          onBlur: function onBlur(e) {
            d(), c && c(e);
          }
        }));
      };
    t.BasicText = l;
    var d = (0, o.default)(l);
    t.default = d;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BasicRadio = void 0;
    var a = n(r(2)),
      u = n(r(3)),
      i = n(r(1)),
      o = n(r(21)),
      l = function Radio(e) {
        var t = e.radioGroupApi,
          r = e.radioGroupState,
          n = (0, u.default)(e, ["radioGroupApi", "radioGroupState"]),
          o = r.value,
          l = t.setValue,
          d = t.setTouched,
          f = t.onChange,
          c = t.onBlur,
          s = n.value,
          p = n.onChange,
          h = n.onBlur,
          v = n.field,
          g = (n.initialValue, n.forwardedRef),
          m = (0, u.default)(n, ["value", "onChange", "onBlur", "field", "initialValue", "forwardedRef"]);
        return i.default.createElement("input", (0, a.default)({}, m, {
          name: v,
          ref: g,
          value: s,
          checked: o === s,
          onChange: function onChange(e) {
            e.target.checked && (l(s), p && p(e), f && f(e));
          },
          onBlur: function onBlur(e) {
            d(), h && h(e), c && c(e);
          },
          type: "radio"
        }));
      };
    t.BasicRadio = l;
    var d = (0, o.default)(l);
    t.default = d;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BasicTextArea = void 0;
    var a = n(r(2)),
      u = n(r(3)),
      i = n(r(1)),
      o = n(r(10)),
      l = function TextArea(e) {
        var t = e.fieldApi,
          r = e.fieldState,
          n = (0, u.default)(e, ["fieldApi", "fieldState"]),
          o = r.value,
          l = t.setValue,
          d = t.setTouched,
          f = n.onChange,
          c = n.onBlur,
          s = n.field,
          p = (n.initialValue, n.forwardedRef),
          h = (0, u.default)(n, ["onChange", "onBlur", "field", "initialValue", "forwardedRef"]);
        return i.default.createElement("textarea", (0, a.default)({}, h, {
          name: s,
          ref: p,
          value: o || "",
          onChange: function onChange(e) {
            l(e.target.value), f && f(e);
          },
          onBlur: function onBlur(e) {
            d(), c && c(e);
          }
        }));
      };
    t.BasicTextArea = l;
    var d = (0, o.default)(l);
    t.default = d;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BasicSelect = void 0;
    var a = n(r(2)),
      u = n(r(3)),
      i = n(r(40)),
      o = n(r(4)),
      l = n(r(5)),
      d = n(r(6)),
      f = n(r(7)),
      c = n(r(8)),
      s = n(r(12)),
      p = n(r(1)),
      h = n(r(10)),
      v = function (e) {
        function Select(e) {
          var t;
          return (0, o.default)(this, Select), (t = (0, d.default)(this, (0, f.default)(Select).call(this, e))).handleChange = t.handleChange.bind((0, s.default)((0, s.default)(t))), t.selectRef = p.default.createRef(), t;
        }
        return (0, c.default)(Select, e), (0, l.default)(Select, [{
          key: "handleChange",
          value: function handleChange(e) {
            var t = (0, i.default)((this.props.forwardedRef || this.selectRef).current).filter(function (e) {
              return e.selected;
            }).map(function (e) {
              return e.value;
            });
            this.props.fieldApi.setValue(this.props.multiple ? t : t[0] || ""), this.props.onChange && this.props.onChange(e);
          }
        }, {
          key: "render",
          value: function render() {
            var e = this.props,
              t = e.fieldApi,
              r = e.fieldState,
              n = (0, u.default)(e, ["fieldApi", "fieldState"]),
              i = r.value,
              o = (t.setValue, t.setTouched),
              l = (n.onChange, n.onBlur),
              d = n.field,
              f = (n.initialValue, n.forwardedRef),
              c = n.children,
              s = n.multiple,
              h = (0, u.default)(n, ["onChange", "onBlur", "field", "initialValue", "forwardedRef", "children", "multiple"]);
            return p.default.createElement("select", (0, a.default)({}, h, {
              multiple: s,
              name: d,
              ref: f || this.selectRef,
              value: i || (s ? [] : ""),
              onChange: this.handleChange,
              onBlur: function onBlur(e) {
                o(), l && l(e);
              }
            }), c);
          }
        }]), Select;
      }(p.default.Component);
    t.BasicSelect = v;
    var g = (0, h.default)(v);
    t.default = g;
  }, function (e, t) {
    e.exports = require("@babel/runtime-corejs2/helpers/toConsumableArray");
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
      u = n(r(3)),
      i = n(r(1)),
      o = function Option(e) {
        var t = e.value,
          r = e.forwardedRef,
          n = e.children,
          o = (0, u.default)(e, ["value", "forwardedRef", "children"]);
        return i.default.createElement("option", (0, a.default)({
          ref: r,
          value: t,
          key: t
        }, o), n);
      };
    t.default = o;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BasicCheckbox = void 0;
    var a = n(r(2)),
      u = n(r(3)),
      i = n(r(1)),
      o = n(r(10)),
      l = function Checkbox(e) {
        var t = e.fieldApi,
          r = e.fieldState,
          n = (0, u.default)(e, ["fieldApi", "fieldState"]),
          o = r.value,
          l = t.setValue,
          d = t.setTouched,
          f = n.onChange,
          c = n.onBlur,
          s = n.field,
          p = (n.initialValue, n.forwardedRef),
          h = (0, u.default)(n, ["onChange", "onBlur", "field", "initialValue", "forwardedRef"]);
        return i.default.createElement("input", (0, a.default)({}, h, {
          name: s,
          ref: p,
          checked: !!o,
          onChange: function onChange(e) {
            l(e.target.checked), f && f(e);
          },
          onBlur: function onBlur(e) {
            d(), c && c(e);
          },
          type: "checkbox"
        }));
      };
    t.BasicCheckbox = l;
    var d = (0, o.default)(l);
    t.default = d;
  }, function (e, t, r) {
    "use strict";

    var n = r(11),
      a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.BasicRadioGroup = void 0;
    var u = a(r(13)),
      i = a(r(4)),
      o = a(r(5)),
      l = a(r(6)),
      d = a(r(7)),
      f = a(r(8)),
      c = n(r(1)),
      s = r(9),
      p = a(r(10)),
      h = function (e) {
        function RadioGroup() {
          return (0, i.default)(this, RadioGroup), (0, l.default)(this, (0, d.default)(RadioGroup).apply(this, arguments));
        }
        return (0, f.default)(RadioGroup, e), (0, o.default)(RadioGroup, [{
          key: "render",
          value: function render() {
            return c.default.createElement(s.GroupContext.Provider, {
              value: this.groupContext
            }, this.props.children);
          }
        }, {
          key: "groupContext",
          get: function get() {
            return {
              radioGroupApi: (0, u.default)({}, this.props.fieldApi, {
                onChange: this.props.onChange,
                onBlur: this.props.onBlur
              }),
              radioGroupState: this.props.fieldState
            };
          }
        }]), RadioGroup;
      }(c.Component);
    t.BasicRadioGroup = h;
    var v = (0, p.default)(h);
    t.default = v;
  }]);
});